<form class="lv-artefact-container lv-component"
      [ngClass]="!!uiArtefakt?.Ausrichtung ? uiArtefakt?.Ausrichtung : uiAusrichtung">
  <div class="lv-artefact" [ngClass]="uiArtefakt.BreiteInPixel">
    <lv-label-tooltip [label]="uiArtefakt.Text" [labelSymbol]="nestedSymbol"
                      [tooltip]="uiArtefakt.InfoTextTooltipCollapsable"
                      [isPflichtfeld]="uiArtefakt.PflichtfeldJN"
                      [isCollapsable]="uiArtefakt.InfoTextTooltipCollapsableTyp === 'Collapsable'"
                      (infotextCollapsableChange)="infotextCollapsableChange($event)"></lv-label-tooltip>
    <lv-info-text-tooltip-collapsable [showInfotext]="showInfotextCollapsable"
                                      [tooltip]="uiArtefakt.InfoTextTooltipCollapsable"></lv-info-text-tooltip-collapsable>
    <lv-material-form-input lvIbanValidator
                            [meldung]="uiArtefakt.UIMeldung | meldung: 'Fehler': true "
                            [placeholder]="''"
                            [(ngModel)]="ibanDisplayString"
                            (inputChange)="changeValue($event, textfeld.valid)"
                            (blur)="onBlur()"
                            #textfeld="ngModel" [name]="uiArtefakt.Identifikator"
                            [outerErrors]="textfeld?.errors" [isTouched]="textfeld?.touched"
                            [required]="uiArtefakt.PflichtfeldJN" [isDirty]="textfeld?.dirty"
                            [textForRequiredError]="uiArtefakt.FehlertextPflichtfeld"
                            [disabled]="isDisabled"
                            [errorPath]="'IBAN'"
                            [autocomplete]="autocomplete">
    </lv-material-form-input>
    <div [@inOut] *ngIf="bankname">
      Bankname: {{bankname}}
    </div>
    <lv-infotext-permanent
        [InfoTextPermanent]="uiArtefakt.InfoTextPermanent"></lv-infotext-permanent>
  </div>
</form>
